// Import Ionic Components
import { IonCard, IonCardSubtitle, IonGrid, IonRow, IonCol, IonSkeletonText, useIonViewWillLeave } from "@ionic/react";

// Import React Libraries
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router";

// Import Css File
import styles from "./searchMainCategories.module.scss";
import classNames from "classnames/bind";

import { Image } from "../../components/Image/Image";
import { useGetAllCategoriesQuery, useGetMainCategoriesQuery } from "../../providers/categories";
import { Category, Product } from "@core/types";
import { ProductsSearchPageLayoutOld } from "../../components/ProductsSearchPageLayoutOld";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const skeletonItemList = [...Array(5).keys()];

const CategoriesSkeleton = () => {
  return (
    <IonGrid>
      <IonRow className={cx("skeletonRow")}>
        {skeletonItemList.map((num) => {
          return (
            <IonCol key={num} sizeSm="6" sizeMd="4" sizeLg="2.36">
              <IonSkeletonText animated={true} className={cx("skeletonCard")}></IonSkeletonText>
              <IonSkeletonText animated={true} className={cx("skeletonText")}></IonSkeletonText>

              <IonSkeletonText animated={true} className={cx("skeletonCard")}></IonSkeletonText>
              <IonSkeletonText animated={true} className={cx("skeletonText")}></IonSkeletonText>

              <IonSkeletonText animated={true} className={cx("skeletonCard")}></IonSkeletonText>
              <IonSkeletonText animated={true} className={cx("skeletonText")}></IonSkeletonText>

              <IonSkeletonText animated={true} className={cx("skeletonCard")}></IonSkeletonText>
              <IonSkeletonText animated={true} className={cx("skeletonText")}></IonSkeletonText>
            </IonCol>
          );
        })}
      </IonRow>
    </IonGrid>
  );
};

const SearchMainCategories: React.FC = (props: any) => {
  let history = useHistory(); // For Push page
  const { t } = useTranslation();
  const [searchResult, setSearchResult] = useState<Product[]>([]);

  const { data: mainCategories, isLoading: isMainCatLoading } = useGetMainCategoriesQuery();
  const { data: { allCategories } = {}, isLoading: isAllCatLoading } = useGetAllCategoriesQuery();
  const isLoading = isAllCatLoading || isMainCatLoading;

  const openSubcategories = useCallback(
    (category: Category) => {
      if (allCategories?.some((x) => x.parent === category.id)) {
        history.push("/categories/" + category.id + "/subcategories", { parentCategory: category });
      } else {
        history.push("/products/" + category.id + "/" + category.name + "/popular");
      }
    },
    [allCategories, history],
  );

  useIonViewWillLeave(() => {
    setSearchResult([]);
  }, [props.match.params]);

  return (
    <ProductsSearchPageLayoutOld pageTitle={t("Catalog")} breadcrumbsTitle={t("Catalog")}>
      {isLoading && <CategoriesSkeleton />}
      {mainCategories?.length && (
        <div className={searchResult.length ? cx("hide") : cx("categoriesList")}>
          {mainCategories?.map((category) => {
            return (
              <IonCard
                className={cx("productCard", "ion-no-margin")}
                key={category.id}
                onClick={() => openSubcategories(category)}
              >
                <Image
                  className={cx(
                    "categoryIcon",
                    `${category.image?.src.includes("svg") ? "image-transform" : "productCard__image"}`,
                  )}
                  id="image"
                  src={category.image?.src}
                  downsize={false}
                />
                <IonCardSubtitle className={cx("productCard__subtitle")}>{category.name}</IonCardSubtitle>
              </IonCard>
            );
          })}
        </div>
      )}
    </ProductsSearchPageLayoutOld>
  );
};

export default SearchMainCategories;
